export default "__VITE_ASSET__SU1md9Xw__"